module.exports = __webpack_public_path__ + "img/icon-telemedicine.da496a43.svg";